import { useNavigate, useParams } from "react-router-dom";
import { API } from "../../config/api";
import { GET, PUT } from "../../utils/apicalls";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  notification,
  Row,
  Select,
} from "antd";
import { useEffect, useState } from "react";
import PageHeader from "../pageHeader/pageheader";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import moment from "moment";

function LeaveUpdateDetails() {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [UsersData, setUsersData] = useState<any>();
  const user: any = useSelector((state: RootState) => state?.user); // Access user state

  const onFinish = async (values: any) => {
    try {
      let obj = {
        employeeId: values.employeeId,
        salaryId: values.salaryId,
        leaveId: values.leaveId,
        approver: values.approver,
        from: values.from?.format("YYYY-MM-DD"),
        to: values.to?.format("YYYY-MM-DD"),
        type: values.type,
        status: values.status,
        description: values.description,
        createdBy: values.createdBy,
      };

      const api = API.UPDATE_LEAVE + id;
      const postRequest = await PUT(api, obj);

      if (postRequest) {
        notification.success({
          message: "Leave details updated successfully",
        });

        navigate(-1);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error("Error updating visitors data:", error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    }
  };
  useEffect(() => {
    getLeaveData();
  }, []);

  const getLeaveData = async () => {
    try {
      let api = API.GET_ONE_LEAVE + id;
      const Data: any = await GET(api, {});
      const leaveData = Data?.data;
      leaveData.from = leaveData.from ? moment(leaveData.from) : null;
      leaveData.to = leaveData.to ? moment(leaveData.to) : null;

      setUsersData(leaveData);
      form.setFieldsValue(leaveData);
    } catch (error) {
      console.log("Error fetching user data:", error);
    }
  };

  // Fetch or handle the leave details using `id`
  return (
    <div>
      <PageHeader />
      <Card>
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                name="approver"
                label="approver"
                rules={[{ required: true, message: "Enter approver" }]}
              >
                <Input placeholder="approver" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="from"
                label="from"
                rules={[{ required: true, message: "Enter from" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="to"
                label="to"
                rules={[{ required: true, message: "Enter to" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="status"
                label="Status"
                rules={[{ required: true, message: "Select status" }]}
              >
                <Select placeholder="Select status">
                  <Select.Option value="approved">Approved</Select.Option>
                  <Select.Option value="rejected">Rejected</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="description" label="description">
                <Input.TextArea placeholder="description" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item name="createdBy" label="createdBy">
                <Select placeholder="Select ">
                  <Select.Option value="admin">Admin</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="type"
                label="Leave Type"
                rules={[{ required: true, message: "Select leave type" }]}
              >
                <Select placeholder="Select leave type">
                  <Select.Option value="sick">Sick</Select.Option>
                  <Select.Option value="vacation">Vacation</Select.Option>
                  <Select.Option value="maternity">Maternity</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {/* Buttons */}
          <Row className="mt-4" gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Button
                onClick={() => navigate(-1)}
                size="large"
                block
                className="cancel-button"
              >
                Cancel
              </Button>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                block
                className="update-button"
              >
                Update
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
}

export default LeaveUpdateDetails;
